var  gifter_obj,gifter_logic, gifter_logic_,gifter_condition,gifter_condition_object,condition2,condition3,customization;

var gifter_params = {
        data:null,
        templates:null,
        lastscroly:0,
        lastscroldir:'',
        slidehandle:'',
        stickyT:0,
        giftdatasku:[],
        giftstemplate:[],
        collections:[],
        collectionsdata:[],
        dataready : false,
        bodytemplateloaded : false,
        dataloaded : false,
        collectionsloaded : false,
        gifttiersloaded: false,
        gifterlogic: {},
        gifttiers:null,
        giftConditionPriority:{},
        currentTemplate:null,
        currentcart:null,
        selectedcollection:null,
        selectedgiftid:null,
        selectedgiftsku:null,
        selectedprimerykey:null,
        selectedsunglasses:null,
        selectedaccessory:null,
        selecteditem:null,
        addtocartprimerykeys:[]
}




gifter_logic = (function(){

    var params = gifter_params;
    
    var freegiftprice = 400; //3000$
    
    var mycart = null;
    
    var glasses = {};
    
    var cartVal = 0;
    
    var aftercartupdateTimer = null;
    
    var autopopup = true;
    
    var makeitagiftenable = false;
    
    var sunglassesmode = false;
    
    var itemsmode = false;

    var init = function(){

        //console.log(params);

        giftlogicpriority(); 

        pagecart();

    } 
    
    /* For page Cart (not popup cart) */
    var pagecart = function(){

        if (location.href.indexOf('https://torgoen.com/cart') > -1){

            giftcartevents();
        }

    }

    var getCookie = function(cname){
    
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";

    }
    
    var setCookie = function(cname, cvalue, exdays){
    
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";

    }
    
    var selectitem = function(){
    
        var escapeSku = params.selecteditem;

        if (escapeSku.indexOf('/') > -1){

            escapeSku = escapeSku.replace("/","\\/");
        }


        //console.log(escapeSku);

        if (params.selecteditem == null || params.selecteditem == '' || typeof(params.selecteditem) == 'undefined'){
          return;
        }

        var text = $('.' + params.currentTemplate + ' div[sku="' + escapeSku + '"] .gifttitle').text();

        if (text.indexOf('|') > -1){
          text = text.split('|')[0];
        }

        //console.log(text);

        $('.' + params.currentTemplate + ' .giftpackimage img.gifimgright').attr('src',$('.' + params.currentTemplate + ' .gift-' + escapeSku).attr('src'));

        //$('.' + params.currentTemplate + ' .giftpackimage .gsku_').text(params.selecteditem);

        $('.' + params.currentTemplate + ' #giftglasstext div').text(text);
      
        $('.' + params.currentTemplate + ' .gift-glasses-choice .giftselected').hide();
      
        $('.' + params.currentTemplate + ' div[sku="'+ escapeSku +'"] .giftselected').show();
      
        params.itemchoicestr = params.selecteditem;

        window.setTimeout(function(){
        
          changeglassesclose();
          
        },500);
      
    }    
    
    var selectsunglasses = function(){
    
        console.log(params.selectedsunglasses);

        if (params.selectedsunglasses == null || params.selectedsunglasses == '' || typeof(params.selectedsunglasses) == 'undefined'){
          return;
        }

        //console.log('selectsunglasses ' + params.selectsunglasses);

        var text = $('.' + params.currentTemplate + ' div[sku="'+params.selectedsunglasses+'"] .gifttitle').text();

        if (text.indexOf('|') > -1){
          text = text.split('|')[0];
        }

        //console.log(text);

        var escapeSku = params.selectedsunglasses;

        if (escapeSku.indexOf('/') > -1){

            escapeSku = escapeSku.replace("/","\\/");
        }

        //console.log(escapeSku);

        $('.' + params.currentTemplate + ' .giftpackimage img.gifimgright').attr('src',$('.' + params.currentTemplate + ' .gift-' + escapeSku).attr('src'));

        $('.' + params.currentTemplate + ' .giftpackimage .gsku_').text(params.selectedsunglasses);

        $('.' + params.currentTemplate + ' #giftglasstext div').text(text);
      
        $('.' + params.currentTemplate + ' .gift-glasses-choice .giftselected').hide();
      
        $('.' + params.currentTemplate + ' div[sku="' + escapeSku + '"] .giftselected').show();
      
        params.glasseschoicestr = params.selectedsunglasses;

        window.setTimeout(function(){
        
          changeglassesclose();
          
        },500);
      
    }
    
    var selectaccessory = function(){
    
        var escapeSku = params.selectedaccessory;

        if (escapeSku.indexOf('/') > -1){

            escapeSku = escapeSku.replace("/","\\/");
        }

        if (params.selectedaccessory == null || params.selectedaccessory == '' || typeof(params.selectedaccessory) == 'undefined'){
          return;
        }

        //console.log('selectaccessory ' + params.selectedaccessory);

        var text = $('.' + params.currentTemplate + ' div[sku="' + escapeSku + '"] .gifttitle').text();

        if (text.indexOf('|') > -1){
          text = text.split('|')[0];
        }

        $('.' + params.currentTemplate + ' .giftpackimage img.gifimgright').attr('src',$('.' + params.currentTemplate + ' .gift-' + escapeSku).attr('src'));

        $('.' + params.currentTemplate + ' #giftglasstext div').text(text);
      
        $('.' + params.currentTemplate + ' .gift-items-choice .giftselected').hide();
      
        $('.' + params.currentTemplate + ' div[sku="' + escapeSku + '"] .giftselected' ).show();
      
        params.itemschoicestr = params.selectedaccessory;

        window.setTimeout(function(){
        
          changeitemsclose();
          
        },500);
      
    }

    var getitemtoadd = function(event){

      var return_ = null;

      return_ = params.selectedgiftid;
      
      return return_;
    
    }

    var collectselection = function(ann){
    
      var ann_ = [];
      
      ann_ = ann_.concat(ann);
      
      var freegiftallow = ann_[0];
      var paidgiftallow = ann_[1];
      var st = '';
      
      //st += $('input[name="chkgloves"]')[0].checked ? 'Gloves' : '';
      //st += $('input[name="chkwallet"]')[0].checked ? '| Wallet' : '';
      //st += $('input[name="chkwrap"]')[0].checked ? ' | Wrap' : '';
      st += ' | ' + params.selectedglasses;
    
      
      var selectedgift = getselectedgiftset(cartVal/100);
      
      return selectedgift;
    }
     
    var modifypopup = function(dataobj){

        var handle = params.currentTemplate;

        var val = dataobj;

        //if (handle == 'gift-singlechoice-1'){

            $('.' + handle + ' .toptitle_ h2').html(val.ui.titles[".toptitle_ h2"]);
            $('.' + handle + ' .gift-price').html(val.ui.titles[".gift-price"]);
            $('.' + handle + ' .gift-compairat').html(val.ui.titles[".gift-compairat"]);
            
            if (val.ui.titles["item_title_style_top"] != ''){

                $('.itemscustomize.sunglasses-select').css('top', val.ui.titles["item_title_style_top"]);
            }

            if (val.ui.titles[".gift-inner-2 .toptitle_ h4"] == 'hide'){
                $('.' + handle + ' .gift-inner-2 .toptitle_ h4').hide();}
            else{
                $('.' + handle + ' .gift-inner-2 .toptitle_ h4').html(val.ui.titles[".gift-inner-2 .toptitle_ h4"]);}

            if (val.ui.titles[".gift-line ._el1"] == 'hide'){
                $('.' + handle + ' .gift-line ._el1').hide();}
            else{
                $('.' + handle + ' .gift-line ._el1').html(val.ui.titles[".gift-line ._el1"]);}

            if (val.ui.titles[".gift-line ._el2"] == 'hide'){
                $('.' + handle + ' .gift-line ._el2').hide();}
            else{
                $('.' + handle + ' .gift-line ._el2').html(val.ui.titles[".gift-line ._el2"]);}


            var customized_button = false;
            var customize_button = val.ui.titles[".itemscustomize button"].toLowerCase();
            if ( customize_button == 'hide' || customize_button == 'none' || customize_button == ''){
                $('.' + handle + ' .itemscustomize button').hide();}
            else{
                $('.' + handle + ' .itemscustomize button').show();
                $('.' + handle + ' .itemscustomize button').text(val.ui.titles[".itemscustomize button"]);
                customized_button = true;
              }


            var buttontop =  val.ui.titles[".itemscustomize button top"].toLowerCase();   
            if ( buttontop == '' || buttontop.indexOf('0em') == -1 || buttontop.indexOf('0px') == -1){

                if (customized_button){

                    $('.' + handle + ' .gift-sun-text').css('top','-2em');
                }
            }
            else{

                $('.' + handle + ' .gift-sun-text').css('top',val.ui.titles[".itemscustomize button top"].toLowerCase());
            }

            addupsalethumb(dataobj);

            //}
    }
    
    var linkclick = function(){
    
      //try{hj('trigger', 'giftpack');}catch(e){}
      
	  console.log(params.currentTemplate);
      
      window.scrollTo(0,0);
      
      $('.ajaxcart__overlay').addClass('gift-screen');
      $('.giftw.' + params.currentTemplate).fadeIn();
      $('.' + params.currentTemplate + ' .gift-wrapper').animateCss('slideInDown', function() {});
    }
  
    var countitemsku = function(cart, itemsku){

      var items = 0;

      if (cart == null){
        return 0;
      }

      //console.log('countproducttype');

      for (var i = 0 ; i < cart.items.length ; i++){
      

        //console.log(cart.items[i].product_type);

        if (cart.items[i].sku == itemsku){
            items += cart.items[i].quantity;

        }
      }

      return items;
    }

    var countproducttype = function(cart, type){

      var items = 0;

      if (cart == null){
        return 0;
      }

      //console.log('countproducttype');

      for (var i = 0 ; i < cart.items.length ; i++){
      

        //console.log(cart.items[i].product_type);

        if (cart.items[i].product_type == type){
            items += cart.items[i].quantity;

        }
      }

      return items;

    }

    var giftlogicpriority = function(){

        $(params.data["gifts_popup_2097191"]).each(function(index,val){

            if ($(val)[0].enable){

              $(val)[0].primerykey = 'gift_' + index;

              if ($(val)[0].logic){

                  params.giftConditionPriority[$(val)[0].primerykey] = $(val)[0].logic['logicpriority1min-5max'];
              } 
            }
        });

        // sort gifts priority logic
        var sortable = [];
        for (var primerykey in params.giftConditionPriority) {
            sortable.push([primerykey, params.giftConditionPriority[primerykey]]);
        }

        sortable.sort(function(a, b) {
            return b[1] - a[1];
        });


        params.giftConditionPriority = {}
        sortable.forEach(function(item){
          params.giftConditionPriority[item[0]]=item[1]
        });

        //console.log(params.giftConditionPriority);
    }

    var getobjectbykey = function(obj, key){

      var out = false;

      $(obj).each(function(index,val){

          if (key in val){

              out = val; 
          }

      });

      return out;

    }

    var getgiftidbysku = function(collectionname, giftsku){

      var indx = params.collections.indexOf(collectionname);

      var collectiondata = params.collectionsdata[indx];

      var return_ = 0;

      /*
      console.log(collectionname);
      console.log(giftsku);
      console.log(params.selectitem);
      console.log(indx);
      console.log(collectiondata);
      */
      

      $(collectiondata.data.shop.collectionByHandle.products.edges).each(function(index,val){

          var title = val.node.title;
          var availableForSale = val.node.variants.edges[0].node.availableForSale;
          var compareAtPrice = val.node.variants.edges[0].node.compareAtPrice;
          var id = val.node.variants.edges[0].node.id;
          var price = val.node.variants.edges[0].node.price;
          var sku = val.node.variants.edges[0].node.sku;
          var image = ""; 

          try{
              image = val.node.variants.edges[0].node.image.originalSrc;
            }
          catch(e) {}

          if (sku == giftsku && availableForSale){

              return_ = id;

              p = atob(return_).split('/');

              return_ = p[p.length-1];

          }
      });

      return return_;

    }

    var getobjectbysku = function(sku){

      var out = false;

      $(params.data["gifts_popup_2097191"]).each(function(index,val){

          if (val.sku == sku){

              out = val; 
          }

      });

      return out;

    }

    var getobjectbyprimerykey = function(primerykey){

      var out = false;

      $(params.data["gifts_popup_2097191"]).each(function(index,val){

          if (val.primerykey == primerykey){

              out = val; 
          }

      });

      return out;

    }

    var getgiftidbyprimerykey = function(primerykey){

      var giftid = 0;

      var obj = getobjectbyprimerykey(primerykey);

      var giftsku = obj.customizations[0].selectedsku;

      $(params.gifttiers.variants).each(function(index,val){

          if (val.sku == giftsku){

              giftid = val.id;
          }

      });

      return giftid;

    }

    var cartlogic = (function(){

      var operator;
      var condition;
      var object;
      var evaluation;
      var value;
      var return_ = true;

      var init = function(logic,cartvalue,cart){

      /*
      console.log(logic);
      console.log(cartvalue);
      console.log(cart);
      */

      operator = logic.operator;

      return_ = true;

      $(logic.condition).each(function(indx,val){

          //console.log(indx);


          object = val['object'];
          evaluation = val['evaluation'];
          value = val['value'];

          m = numericevaluation(cartvalue);
          i = hasitemvaluation(cart);
          s = hasitemsku(cart,value);

          /*
          console.log('m: ' + m);
          console.log('i: ' + i);
          console.log('s: ' + s);
          */

          if (m != null){
            return_ = eval(return_ + ' ' + operator + ' ' + m);
          }

          if (i != null){
            return_ = eval(return_ + ' ' + operator + ' ' + i);
          }

          if (s != null){
            return_ = eval(return_ + ' ' + operator + ' ' + s);
          }
          /*
          if (t != null){
            return_ = eval(return_ + ' ' + operator + ' ' + t);
          }*/

          //console.log(i);

      });

      //console.log(return_);

      return return_;
      }

      var numericevaluation = function(cartvalue){

        if (evaluation == '>' || evaluation == '<' || evaluation == '='){

            var conditionstring = cartvalue/100 + ' ' + evaluation + ' ' + value;

            var condition_ = eval(conditionstring);

            return condition_;
        }

        return null;

      }

      var hasitemsku = function(cart,value){

        if (evaluation == "has item sku"){

              var items = countitemsku(cart, value);

              if (items > 0){

                  return_ =  true;
              }
              else{

                  return_ =  false;
              }

        }

        return null;

      }

      var hasitemvaluation = function(cart){

      var return_ = false;

      if (evaluation == "has item type" || evaluation == "has not item type"){

          if (evaluation == "has item type"){

            //console.log("has item type");

            var items = countproducttype(cart, value);

            if (items > 0){

                return_ =  true;
            }
            else{

                return_ =  false;
            }
          }

          if (evaluation == "has not item type"){
                
                var items = countproducttype(mycart, value);

                if (items == 0){

                    return_ = true;
                }
                else{

                    return_ = false;
                }
          }

          return return_;

      }

      return null;
      
      }


      return {

          init:init

      }

    })();

    var fillpopup = function(id,sku,image,title,templatehandleid){
      
        var c1 = $("<div data='"+id+"' sku='"+sku+"' />");
        var m1 = $("<img class='gift-"+sku+"' src='"+image+"' />");
        var s1 = $("<span class='gifttitle'>" + title + "</span>");
        var s2 = $("<span class='giftselected'>selected</span>");

        $(c1).append(m1);
        $(c1).append(s1);
        $(c1).append(s2);

        //console.log(sku);
        //console.log(c1[0]);

        $('.' + params.currentTemplate + ' #' + templatehandleid).append(c1);

        params.gifterlogic[sku] = title;

    }

    var drawcollectioninpopup = function(collectiondata,templatehandleid,items){


        var itemstring = JSON.stringify(items);


        if (params.currentTemplate.indexOf('single') > -1){

            // decide if populating the accessories (right) or the sunglasses (left)
            if (templatehandleid.indexOf('sunglasses') > -1){
                
                // populate right
                $('.gifimgleft').hide();
                $('.gifimgright').show();
                $('.gsku_').show();
                $('.itemscustomize.accessories-select').hide();
                $('.itemscustomize.sunglasses-select').show();
            }
            else{

               // populate left
                $('.gifimgleft').show();
                $('.gifimgright').hide();
                $('.gsku_').hide();
                $('.itemscustomize.accessories-select').show();
                $('.itemscustomize.sunglasses-select').hide();

            }

        }
        else{
                // show all
                $('.gifimgleft').show();
                $('.gifimgright').show();
                $('.gsku_').show();
                $('.itemscustomize.accessories-select').show();
                $('.itemscustomize.sunglasses-select').show();
        }


        $('.' + params.currentTemplate + ' #' + templatehandleid).html('');

        $(collectiondata.data.shop.collectionByHandle.products.edges).each(function(index,val){

            var title = val.node.title;
            var availableForSale = val.node.variants.edges[0].node.availableForSale;
            var compareAtPrice = val.node.variants.edges[0].node.compareAtPrice;
            var id = val.node.variants.edges[0].node.id;
            var price = val.node.variants.edges[0].node.price;
            var sku = val.node.variants.edges[0].node.sku;
            var image = "";

            try{
              image = val.node.variants.edges[0].node.image.originalSrc;
            }catch(e){}

            if (availableForSale){

                  if (typeof(itemstring) != 'undefined'){

                    //console.log(itemstring);
                    //console.log(sku);

                    if (itemstring.indexOf(sku) > -1){

                      fillpopup(id,sku,image,title,templatehandleid);

                    }
                }

                else{

                      fillpopup(id,sku,image,title,templatehandleid);
                }
            }
        });
    }

    var populatepopup = function(dataobj){

        var template = dataobj.ui.template;
        var customizations = dataobj.customizations;
        
        //console.log(dataobj);

        $(customizations).each(function(index_,val_){

            if ("collection" in val_){

                if (dataobj.collection != ""){

                    if (params.collections.includes(val_.collection)){

                        // find the index of the collection
                        var indx = params.collections.indexOf(val_.collection);

                        var collectiondata = params.collectionsdata[indx];

                        var templatehandleid = val_["template-handle-id"];

                        //console.log(params.collections);
                        //console.log(params.collectionsdata);

                        drawcollectioninpopup(collectiondata,templatehandleid,val_.items);

                    }
                }
            }

            //console.log(val_);

            if ("selectedsku" in val_){

                params.selecteditem = val_.selectedsku;

                /*

                if (val_.collection.toLowerCase() == "accessories"){
                  params.selectedaccessory = val_.selectedsku;

                }else{
                  if (val_.collection.toLowerCase() == "sunglasses"){
                    params.selectedsunglasses = val_.selectedsku;
                    //console.log("2 " + params.selectedsunglasses);
                  }
                  else{
                      params.selecteditem = val_.selectedsku;
                  }
              }
              */

            }



        });
                
    }

    var popupevents = function(){

        $.fn.extend({
          animateCss: function(animationName, callback) {
            var animationEnd = (function(el) {
              var animations = {
                animation: 'animationend',
                OAnimation: 'oAnimationEnd',
                MozAnimation: 'mozAnimationEnd',
                WebkitAnimation: 'webkitAnimationEnd',
              };

              for (var t in animations) {
                if (el.style[t] !== undefined) {
                  return animations[t];
                }
              }
            })(document.createElement('div'));

            this.addClass('animated ' + animationName).one(animationEnd, function() {
              $(this).removeClass('animated ' + animationName);

              if (typeof callback === 'function') callback();
            });

            return this;
          }

        });

        //console.log('popupevents');

        $('.' + params.currentTemplate + ' button.change-glass').click(function(){
              changeglassesopen();
        }); 

        $('.' + params.currentTemplate + ' button.change-items').click(function(){
              changeitemsopen();
        });

        $('.' + params.currentTemplate + ' .giftok').click(function(){

              changeitemsclose();
        });

        $('.' + params.currentTemplate + ' .gift-close').click(function(){

          if (sunglassesmode){

            changeglassesclose();

            return;
          }

          if (itemsmode){

            changeitemsclose();

            return;
          }


          $('.' + params.currentTemplate + ' .gift-wrapper').removeClass('slideInDown');
          $('.' + params.currentTemplate + ' .gift-wrapper').animateCss('fadeOutUp', function() {
            //$('.gift-wrapper').removeClass('fadeOutUp');
            $('.giftw.' + params.currentTemplate).hide();
          });

          $('.ajaxcart__overlay').removeClass('gift-screen');

          // -- to close in IE
            window.setTimeout(function(){$('.giftw.' + params.currentTemplate).fadeOut('slow');},1000);
        });

        $('.' + params.currentTemplate + ' .gift-addtocart button').click(function(event){

                //console.log('add to cart1');

                addtocartclick(event);
        });

        $('.' + params.currentTemplate + ' .gift-glasses-choice #sunglasses-select div').click(function(){

              params.selectedsunglasses = $(this).attr('sku');

              params.selectedgiftsku = params.selectedsunglasses;

              params.selectedgiftid = getgiftidbysku(params.selectedcollection, params.selectedgiftsku);

              selectsunglasses();
        });

        $('.' + params.currentTemplate + ' .gift-items-choice #accessories-select div').click(function(){

              params.selectedaccessory = $(this).attr('sku');

              params.selectedgiftsku = params.selectedaccessory;

              params.selectedgiftid = getgiftidbysku(params.selectedcollection, params.selectedgiftsku);

              //console.log(params.selectedaccessory);
              //console.log(params.selectsunglasses);

              selectaccessory();
        });

        $('.' + params.currentTemplate + ' .gift-items-choice input').click(function(){

              checkclick(this);
        });

        //selectsunglasses();
        //selectaccessory();
        selectitem();

    }

    var addtocartshopify = function(id){

          //console.log(id);

          //return;

          var p = params.selectedaccessory + ' | ' + params.selectedsunglasses;

          if (p.trim()[p.trim().length-1] == "|"){
              // remove trailing |
              p = ' | ' + p.trim().substring(0,p.trim().length-1);
          }          

          /*
          $.ajax({
          type: "POST",
          url: '/cart/add.js',
          dataType: 'JSON',
          data: {
            quantity: 1,
            id: id,
            "properties[Items]": p 
          },
          success: function(response){

                aftercartupdate(response);
          }});
          */

          $.ajax({
          type: "POST",
          url: '/cart/add.js',
          dataType: 'JSON',
          data: {
            quantity: 1,
            id: id
          },
          success: function(response){

                aftercartupdate(response);
          }});


      $('.gift-close').trigger('click');

    }

    var applycoupon = function(){

        var dataobj = getobjectbyprimerykey(params.selectedprimerykey);

        if (dataobj.discountMode == 'shopifycoupon'){

          $.get( "/discount/" + dataobj.couponName, function(data) {
            
            console.log(dataobj.couponName + ' applied');
            
          });

        }
        else{


        }

    }

    var addtocartclick = function(event){
      
      //console.log('add to cart');

      var giftbundleId = getitemtoadd(event);
    
      //console.log(giftbundleId);

      if (giftbundleId != null) {

            addtocartshopify([giftbundleId]);

      }
    }
    
    var aftercartupdate = function(response){
      
        location.href="/cart";

        //ajaxifyShopify.cartUpdateCallback(response);

    }

    var updategiftsn = function(qty,id){

        $.ajax({
          type: "POST",
          url: '/cart/change.js',
          dataType: 'JSON',
          data: {
            quantity: qty,
            id: id
          },
          success: function(response){

            aftercartupdate(response);

          }
        });
      
    }

    var clearcart = function(){

        $.ajax({
          type: "POST",
          url: '/cart/clear.js',
          dataType: 'JSON',
          success: function(response){

            aftercartupdate(response);

          }
        });
    }

    var countgiftnwatches = function(cart){
    
      var cartitems = {};
      
      cartitems['totalValue'] = 0; 
      
      for (var i = 0 ; i < cart.items.length ; i++){
      
          /*
          if (cart.items[i].product_type == 'Watches'){
              watches += cart.items[i].quantity; 
              totalwatchValue += cart.items[i].final_line_price;
          }
          */

          if (typeof(cartitems[cart.items[i].product_type]) == 'undefined'){

              cartitems[cart.items[i].product_type] = cart.items[i].quantity;
              cartitems[cart.items[i].product_type + '_value'] = cart.items[i].final_line_price;

          }
          else{

              cartitems[cart.items[i].product_type] += cart.items[i].quantity;
              cartitems[cart.items[i].product_type + '_value'] += cart.items[i].final_line_price;
          }

          cartitems['totalValue'] += cartitems[cart.items[i].product_type + '_value'];

      }
      
      /*

      cartitems = {
        'totalValue':70000,
        'watches':1,
        'watches_value':4700,
        'sunglasses':4,
        'sunglasses_value':1500,
        'accesories':3,
        'accesories_value':8000,
      }

      */

      return cartitems;
    }

    // selects the proper gifts
    var analayzcart = function(cartitems,cart){
    

        var returnvalue = 0;

        var cartvalue = cart.total_price;

        var found = false;

        $(Object.keys(params.giftConditionPriority)).each(function(index,primerykey){

            var obj = getobjectbyprimerykey(primerykey);
            
            /*
            console.log(obj);
            console.log(primerykey);
            console.log(params.collections);
            console.log(params.collectionsdata);
            */

            //console.log('primerykey:' + primerykey);
            


            if (obj != false && !found){

              //console.log('found');

              if (cartlogic.init(obj.logic,cartvalue,cart)){

                  //console.log(obj);

                  //var collectionname = "accessories";

                  if (params.selectedgiftsku == '' || params.selectedgiftsku == null){

                      params.selectedgiftsku = obj.customizations[0].selectedsku;
                      params.selectedcollection = obj.customizations[0].collection;
                  }

                  //console.log(params.selectedgiftsku);
                  //console.log(params.collections);
                  //console.log(params.selectedcollection);

                  params.selectedgiftid = getgiftidbysku(params.selectedcollection, params.selectedgiftsku);
                  params.selectedprimerykey = primerykey;

                  //console.log('params.selectedgiftid:' + params.selectedgiftid);

                  found = true;

                  //console.log(params.selectedgiftid);
                  //console.log(atob(params.selectedgiftid));

                  returnvalue = params.selectedgiftid;
              }
            }
        });
      
        //console.log('return value:' + returnvalue);

        return returnvalue;
    
    }
    
    var setparamsdefaults = function(){

        params.selectedsunglasses = '';
        params.selectedaccessory = '';

    }

    var additionalimagesRotate = function(dir){

        var p = $('.giftpackimage img:not(.hide_)');

        if (dir == 'right'){
          if ($(p).next().length > 0 && ($(p).next().attr('class').indexOf('additionalimages') > -1 || $(p).next().attr('class').indexOf('gifimgright') > -1)){
              move_($(p), $(p).next());
          }
          else{
              move_($(p), $('.giftpackimage img').first());
          }
        }

        if (dir == 'left'){
          if ($(p).prev().length > 0 && ($(p).prev().attr('class').indexOf('additionalimages') > -1 || $(p).prev().attr('class').indexOf('gifimgright') > -1)){
              move_($(p), $(p).prev());
          }
          else{
              move_($(p), $('.giftpackimage img').last());
          }
        }

        function move_(a, next){

            $(a).hide();
            $(a).addClass('hide_');
            $(a).css('display','none');
            $(next).removeClass('hide_');
            $(next).css('opacity',0);
            $(next).css('display','block');
            $(next).animate({opacity:1},500);

        }

    }

    var addupsalethumb = function(dataobj){

        $('.giftpackimage .additionalimages').remove();
        $('.giftpackimage .rgt_').remove();
        $('.giftpackimage .lft_').remove();

        if (dataobj.ui.additionalimages.length > 0){

          $('.giftpackimage .gsku_').remove();

          dataobj.ui.additionalimages.forEach(function(val){

              $('.giftpackimage').append('<img class="additionalimages hide_" src="' + val + '" />');

          });

          $('.giftpackimage').append('<div class="rgt_"></div>');
          $('.giftpackimage').append('<div class="lft_"></div>');

          $('.giftpackimage .rgt_').click(function(){
              additionalimagesRotate('right');
          });

          $('.giftpackimage .lft_').click(function(){
              additionalimagesRotate('left');
          });

        }
    }

    var modifycartmodal = function(dataobj){

        var animate = function(){

            animateCSS('.gifterpoplabel', 'swing', function() {
              // Do something after animation
            })

        }

        
        if (dataobj.ui.cart.label_enable){

            if ($('#AjaxifyCart').length > 0){

                if ($('#AjaxifyCart .gifterpoplabel').length == 0){

                  $('#AjaxifyCart').append("<div class='gifterpoplabel'></div>");

                  $('.gifterpoplabel').html("<i class='fa fa-gift' aria-hidden='true'></i> " + dataobj.ui.cart.label_text);

                  animate();

                  //console.log("dataobj.ui.cart.label_text: " + dataobj.ui.cart.label_text);

                  $('.gifterpoplabel').click(function(){

                      linkclick();

                  });

                }

                else{

                  $('.gifterpoplabel').html("<i class='fa fa-gift' aria-hidden='true'></i> " + dataobj.ui.cart.label_text);

                  animate();

                }
            }

        }
        

    }

    var popupeligiablecart = function(cartitems,dataobj){

      if (cartitems[dataobj.customizations[0].productType] != 'undefined'){

        if (cartitems[dataobj.customizations[0].productType] > 0){

            // Gift was used already
            return false;
        }

      }
      return true;
    }

    var giftcarteventprocess = function(cart){

        //console.log(cart);

        params.selectedgiftsku = null;
        params.selectedcollection = null;
        params.currentcart = cart;

        var cartitems = countgiftnwatches(cart);

        // returns giftid or 0 if none found
        var ann = analayzcart(cartitems,cart);

        var dataobj = getobjectbyprimerykey(params.selectedprimerykey);

      	//console.log(dataobj);
      
        if (ann !=0 && popupeligiablecart(cartitems,dataobj)){

            params.currentTemplate = dataobj.ui.template.split('.')[0];

            populatepopup(dataobj);
            popupevents();
            modifypopup(dataobj);
			
            giftcartevents_timer = window.setTimeout(function(){

              // Show popup 
              cartEventsActions(dataobj);
              
            },2000);
        }

    }

    // ***** CART EVENTS *****
    var giftcartevents_timer = null;
    var giftcartevents = function(cart){

         clearTimeout(giftcartevents_timer);

         //console.log(cart);

         if (cart == null || typeof(cart) == 'undefined'){

           $.ajax({
            type: "GET",
            url: '/cart.js',
            dataType: 'JSON',
            data: {},
            success: function(cart){

                  giftcarteventprocess(cart);

                }
           });   
         }
         else{

                  giftcarteventprocess(cart);

         }

    }
    
    var cartEventsActions = function(dataobj){

      if (params.dataready){

        // invoke only once each time of popup

        modifycartmodal(dataobj);

        var cookie = getCookie('giftpopup');

        if (cookie.indexOf(params.selectedprimerykey) == -1) {
            setCookie('giftpopup',cookie + '|' + params.selectedprimerykey, 1);
            linkclick();
        }  

        if (location.href.indexOf('gifterdebug') > -1){

            linkclick();
        }

      }
      else{

        console.log('popup data not ready');
      }

    }

    var changeglassesclose = function(){
    
        sunglassesmode = false; 

        $('.' + params.currentTemplate + ' .gift-glasses-choice').hide();
        $('.' + params.currentTemplate + ' .giftpackimage').show();
        $('.' + params.currentTemplate + ' .gift-r').show();
        $('.' + params.currentTemplate + ' .giftpackimage').animateCss('fadeIn', function() {});
        $('.' + params.currentTemplate + ' .gift-r').animateCss('fadeIn', function() {});
        $('.' + params.currentTemplate + ' .gifter-bottompart').css('bottom','10px');
        $('.' + params.currentTemplate + ' .toptitle_ h4').show();

    }
    
    var changeglassesopen = function(){
    
      
        sunglassesmode = true;
      
        $('.' + params.currentTemplate + ' .gift-r').hide();
        $('.' + params.currentTemplate + ' .giftpackimage').hide();
        $('.' + params.currentTemplate + ' .gift-glasses-choice').show();
        $('.' + params.currentTemplate + ' .gift-glasses-choice').animateCss('fadeIn', function() {});
        $('.' + params.currentTemplate + ' .gifter-bottompart').css('bottom','0px');
        $('.' + params.currentTemplate + ' .toptitle_ h4').hide();


    }
    
    var changeitemsclose = function(){
    
        itemsmode = false;  

        $('.' + params.currentTemplate + ' .gift-r').show();
        $('.' + params.currentTemplate + ' .gift-items-choice').hide();
        $('.' + params.currentTemplate + ' .giftpackimage').show();
        $('.' + params.currentTemplate + ' .giftpackimage').animateCss('fadeIn', function() {});
        $('.' + params.currentTemplate + ' .gift-r').animateCss('fadeIn', function() {});
        $('.' + params.currentTemplate + ' .gifter-bottompart').css('bottom','10px');
        $('.' + params.currentTemplate + ' .toptitle_ h4').show();

    }
    
    var changeitemsopen = function(){

        itemsmode = true;

        $('.' + params.currentTemplate + ' .gift-r').hide();
        $('.' + params.currentTemplate + ' .giftpackimage').hide();
        $('.' + params.currentTemplate + ' .gift-items-choice').show();
        $('.' + params.currentTemplate + ' .gift-items-choice').animateCss('fadeIn', function() {});
        $('.' + params.currentTemplate + ' .gifter-bottompart').css('bottom','0px');
        $('.' + params.currentTemplate + ' .toptitle_ h4').hide();

    }
    
    var changeProductAddToCartButton = function(){
    
      if ($('body#add-a-gift-set').length > 0){
        
        $('#AddToCart-product').remove();
        
        var a = $('<a href="/">SHOP NOW</a>');
         
        $('.add-to-cart__wrapper').append(a)
        
      }
    }
    
    function animateCSS(element, animationName, callback) {
        const node = document.querySelector(element)
        node.classList.add('animated', animationName)

        function handleAnimationEnd() {
            node.classList.remove('animated', animationName)
            node.removeEventListener('animationend', handleAnimationEnd)

            if (typeof callback === 'function') callback()
        }

        node.addEventListener('animationend', handleAnimationEnd)
    }

    return{
    
      init:init,
      linkclick: linkclick,
      giftcartevents:giftcartevents,
      glasses:glasses

    }
  
  
  })();


